import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Box, CircularProgress } from '@mui/material';
import { UserRole } from '../models/User';

interface ProtectedRouteProps {
  requireManager?: boolean;
  allowedRoles?: UserRole[];
}

export const ProtectedRoute = ({
  requireManager = false,
  allowedRoles = []
}: ProtectedRouteProps) => {
  const { isAuthenticated, isHotelManager, loading, userRole } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Check manager requirement
  if (requireManager && !isHotelManager) {
    // Redirect to dashboard if user doesn't have manager privileges
    return <Navigate to="/" />;
  }

  // Check role-based access if roles are specified
  if (allowedRoles.length > 0 && userRole && !allowedRoles.includes(userRole)) {
    // Redirect to dashboard if user doesn't have the required role
    return <Navigate to="/" />;
  }

  return <Outlet />;
};